import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { Box } from '@mui/material';

const SemiDonutChart = ({
  data,
  width = 400,
  height = 200,
  innerRadius = 80,
  outerRadius = 100,
  colors = ['#6fbd43', '#ff8542', '#6fbd43', '#ff8542'],
  centerX = 200,
  centerY = 125,
  fleetCount
}) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(data?.title?.text || '', 'text/html');
  const extractedValue = doc.querySelector('span')?.textContent || '';
  const extractedLabel = doc.querySelectorAll('span')?.[1]?.textContent || '';

  return (
    <Box
      sx={{
        outline: 'none',
        border: 'none',
        userSelect: 'none',
        '& svg': { outline: 'none' }
      }}
    >
      <PieChart width={width} height={height}>
        <Pie
          data={(data?.series?.[0]?.data || []).map(d => ({
            ...d,
            value: d.y
          }))}
          cx={centerX}
          cy={centerY}
          startAngle={180}
          endAngle={0}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          cornerRadius={10}
          paddingAngle={2}
          dataKey="value"
        >
          {(data?.series?.[0]?.data || []).map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <text
          x={centerX}
          y={centerY - 20}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="20"
          fontWeight="bold"
          fill="#333"
        >
          {extractedValue}
        </text>
        <text
          x={centerX}
          y={centerY + 2}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="12"
          fill="#666"
        >
          {extractedLabel}
        </text>
      </PieChart>
    </Box>
  );
};

export default SemiDonutChart;
